import React, { Component } from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";

// Images
import bnrImg from "../../images/banner/bnr3.jpg";
import { Helmet } from "react-helmet-async";

class ServicesHeader extends Component {
  render() {
    return (
      <>
        <Helmet>
          <title>Våra Tjänster- Kvalitativ Bilvård för Alla Behov i Göteborg</title>
        </Helmet>
        <div className="page-content bg-white">
          <div className="page-banner ovbl-dark" style={{ backgroundImage: "url(" + bnrImg + ")" }}>
            <div className="container">
              <div className="page-banner-entry text-center">
                <h2 className="banner">
                  <span>Tjänster - {this.props.title}</span>
                </h2>
                <nav aria-label="breadcrumb" className="breadcrumb-row">
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/">
                        <i className="las la-home"></i>Hem
                      </Link>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                      Tjänster
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                      {this.props.title}
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

ServicesHeader.propTypes = {
  title: PropTypes.string.isRequired,
};
export default ServicesHeader;
